@if (hasNonBuyers) {
  <div class="non-buyers-error">
    <p>The following selected companies are not buyers and cannot be added to buyer groups:</p>
    <ul>
      @for (company of nonBuyers; track company.account) {
        <li>{{ company.name }}</li>
      }
    </ul>
    <button mat-button color="warn" (click)="removeNonBuyers()">Remove non-buyers from the list</button>
  </div>
}
@if (hasInactiveBuyers) {
  <div class="non-buyers-error">
    <p>The following buyers do not have active status and cannot be added to buyer groups:</p>
    <ul>
      @for (company of inactiveBuyers; track company.account) {
        <li>{{ company.name }}</li>
      }
    </ul>
    <button mat-button color="warn" (click)="removeInactiveBuyers()">Remove inactive buyers from the list</button>
  </div>
}
@if (hasArchivedBuyers) {
  <div class="non-buyers-error">
    <p>The following buyers are archived and cannot be added to buyer groups:</p>
    <ul>
      @for (company of archivedBuyers; track company.account) {
        <li>{{ company.name }}</li>
      }
    </ul>
    <button mat-button color="warn" (click)="removeArchivedBuyers()">Remove archived buyers from the list</button>
  </div>
}